import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/grading-definitions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/grading-definitions', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const copy = data => {
  return httpClient
    .post('/api/grading-definitions/copy', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/grading-definitions/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/grading-definitions/${data.grade_definition_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const mainProgram = (Options = {}) => {
  return httpClient
    .get('/api/grading-definitions/main-programs')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getSubProgram = (acp_id, Options = {}) => {
  return httpClient
    .get(`/api/grading-definitions/${acp_id}/sub-programs`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getSubProgramCopy = (acp_id, Options = {}) => {
  return httpClient
    .get(`/api/grading-definitions/${acp_id}/sub-program_copys`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  mainProgram,
  copy,
  getSubProgram,
  getSubProgramCopy
}
